import { Injectable } from '@angular/core';
import { BarchartModel } from "./barchart.model";
import { Time } from "src/app/_api/models/time.model";
import { PeriodService } from "../services/period.service";
import { Period } from "../models/period.model";
import { Moment } from "moment";

@Injectable({
  providedIn: 'root'
})
export class ChartHoursByTimetypeInPeriodConverter {
  model: BarchartModel;
  isWeekOrDay: boolean;

  constructor(private periodService: PeriodService) {}

  getConvertedChartModel(times: Time[], fromDate: Moment, toDate: Moment, dateRangeIndex: number): BarchartModel {
    this.model = {} as BarchartModel;
    this.model.dataSource = [];
    this.model.series = [];
    this.isWeekOrDay = dateRangeIndex < 2;

    const periods = this.periodService.getPeriod(fromDate.format("DD.MM.YYYY"), toDate.format("DD.MM.YYYY"), dateRangeIndex);

    times.forEach(t => {
      if (this.model.series.filter(s => s.valueField == t.TimeTypeId).length === 0) {
        this.model.series.push({ valueField: t.TimeTypeId.toString(), name: t.TimeTypeCode });
      };
    });

    periods.forEach((period: Period) => {
      this.tryAddDataForPeriod(period, times);
    });

    return this.model;
  }

  private tryAddDataForPeriod(period: Period, times: Time[]) {
    const fromDate = period.fromDate;
    const toDate = new Date(period.toDate);

    if (this.isWeekOrDay) {
      toDate.setDate(toDate.getDate() + 1);
    }

    const timesWithinPeriod = times.filter(t => new Date(t.Date) >= fromDate && new Date(t.Date) < toDate);

    if (timesWithinPeriod.length === 0) { return []; }

    const result = { period: period.name };

    this.model.series.forEach(s => {
      result[s.valueField] = 0;
    });

    timesWithinPeriod.forEach(t => {
      result[t.TimeTypeId.toString()] += t.TotalHours;
    });

    this.model.dataSource.push(result);
  }
}
